import * as React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { SwapVert } from '@mui/icons-material'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import { IProcurementPlan } from 'types/procurementPlans'
import { formatTimeStampToDateWithTime } from 'hooks/date/formattedTime'
import { useProcurementPlansRelationsQuery } from 'services/procurementPlans'
import { useTranslation } from 'react-i18next'
import { Loading } from 'components/Loading'

const StyledTableCell = styled(TableCell)({
  fontSize: '14px !important',
})
const StyledBox = styled(Box)({
  fontSize: '14px !important',
  textDecoration: 'none',
  color: 'rgb(3, 34, 76)',
  cursor: 'pointer',
})

function Row(props: { row: IProcurementPlan; index: number }) {
  const { row, index } = props
  const [procurementPlanId, setProcurementPlanId] = React.useState<string>('')
  const navigate = useNavigate()
  const { t } = useTranslation()

  const {
    data: correlations,
    refetch,
    isLoading,
  } = useProcurementPlansRelationsQuery(
    { id: procurementPlanId ?? '' },
    { skip: !procurementPlanId }
  )

  const handleClickDetailed = async (id: string) => {
    await setProcurementPlanId(id)
    await refetch().then((res) => {
      if (!('error' in res)) {
        const sortedCorrelations = res
          .data!.slice()
          .sort((a: any, b: any) => (a.version < b.version ? 1 : -1))
        navigate(`/purchase-plans/${sortedCorrelations[0].id}`)
      }
    })
  }

  if (isLoading) {
    return <Loading fullPage={false} />
  }

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <StyledTableCell align="center">{index + 1}</StyledTableCell>
        <StyledTableCell>{row.organizationName}</StyledTableCell>
        <StyledTableCell>{row.year}</StyledTableCell>
        {/*TODO commented on request on 14 Nov*/}
        {/*<StyledTableCell>*/}
        {/*  {formatTimeStampToDateWithTime(row.publishedAt?.toString() as string)}*/}
        {/*</StyledTableCell>*/}
        <StyledTableCell align="center">
          <StyledBox onClick={() => handleClickDetailed(row.id)}>
            {t('detailed')}
          </StyledBox>
        </StyledTableCell>
      </TableRow>
    </React.Fragment>
  )
}

type Props = {
  data: IProcurementPlan[]
}

export function PurchasePlansTable({ data }: Props) {
  const { t } = useTranslation()
  return (
    <Box sx={{ overflow: 'auto' }}>
      <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
        <TableContainer component={Box}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <SwapVert
                    sx={{
                      color: '#8a94a6',
                      fontSize: '22px',
                    }}
                  />
                </TableCell>
                <TableCell>{t('tender-organization-name')}</TableCell>
                <TableCell>{t('year')}</TableCell>
                {/*<TableCell>{t('published-time')}</TableCell>*/}
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <Row key={row.id} row={row} index={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}
